import * as Api from '@/api/product'

const state={
};

const getters={
};

const mutations={
};

const actions={
    //------- 获取已上架的产品列表 ----------
    async GetProductPublishedList(context,data){
        let res = await Api.get_product_published_list(data);
        return res.data.responseObject;
    },
    async GetProductPublishedInfo(context,data){
        let res = await Api.get_product_published_info(data);
        return res.data.responseObject;
    },
    async GetProductPublishedPromote(context,data){
        let res = await Api.get_product_published_promote(data);
        return res.data.responseObject;
    },
    async GetProductPublishedIntroduction(context,data){
        let res = await Api.get_product_published_introduction(data);
        return res.data.responseObject;
    },
    async GetProductPublishedNotice(context,data){
        let res = await Api.get_product_published_notice(data);
        return res.data.responseObject;
    },
    async getUserPromotePoster(context,data){
        let res = await Api.get_user_promote_poster(data);
        return res.data;
    },
    async GetMyOrderList(context,data){
        let res = await Api.get_my_order_list(data);
        return res.data.responseObject;
    },
    async GetSaleToolGroupRuleInfo(context,data){
        let res = await Api.get_sale_tool_group_rule_info(data);
        return res.data.responseObject;
    },
    async GetSaleToolGroupRuleList(context,data){
        let res = await Api.get_sale_tool_group_rule_list(data);
        return res.data.responseObject;
    },
    async GetSaleGroupInfo(context,data){
        let res = await Api.get_sale_group_info(data);
        return res.data.responseObject;
    },
    async DrawCoupon(context,data){
        let res = await Api.draw_coupon(data);
        return res.data;
    },
    async GetUserCouponList(context,data){
        let res = await Api.get_user_coupon_list(data);
        return res.data.responseObject;
    },
    async GetCouponProductList(context,data){
        let res = await Api.get_coupon_product_list(data);
        return res.data.responseObject;
    },
};

export default {
    state,
    getters,
    mutations,
    actions
}
